import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';
import { useCart } from '../context/CartContext';
import ProductImage from '../components/common/ProductImage';
import toast from 'react-hot-toast';

const VD   = '#6D28D9';
const GOLD = '#C9A96E';
const serif = "'Cormorant Garamond', 'Playfair Display', Georgia, serif";
const sans  = "'Montserrat', sans-serif";

export default function LandingPage() {
  const [featured, setFeatured] = useState([]);
  const { addItem } = useCart();

  useEffect(() => {
    api.get('/api/products', { params: { limit: 6 } })
      .then(r => setFeatured((r.data.products || []).slice(0, 6)))
      .catch(() => {});
  }, []);

  const categories = [
    { name: 'Oriental', icon: '🌙', desc: 'Chaud & envoûtant' },
    { name: 'Floral',   icon: '🌸', desc: 'Délicat & romantique' },
    { name: 'Boisé',    icon: '🌲', desc: 'Profond & naturel' },
    { name: 'Frais',    icon: '💨', desc: 'Léger & vivifiant' },
    { name: 'Ambré',    icon: '✨', desc: 'Doux & sensuel' },
    { name: 'Musqué',   icon: '🌿', desc: 'Discret & élégant' },
  ];

  const promises = [
    { icon: '✦', t: 'Authenticité garantie', d: 'Chaque flacon soigneusement sélectionné' },
    { icon: '✦', t: 'Livraison express',      d: 'Partout au Sénégal sous 24 à 48h' },
    { icon: '✦', t: 'Paiement sécurisé',      d: 'Orange Money ou carte bancaire' },
  ];

  return (
    <div style={{ background: '#fff', color: '#111', fontFamily: sans }}>

      {/* ══ HERO ══ */}
      <section style={{
        background: 'radial-gradient(ellipse 80% 80% at 50% 50%, #7C3AED 0%, #5B21B6 30%, #3B0764 65%, #1e0042 100%)',
        minHeight: '100vh',
        display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center',
        textAlign: 'center', padding: '4rem 1.5rem',
        position: 'relative', overflow: 'hidden',
      }}>
        {/* Halo */}
        <div style={{ position: 'absolute', width: 500, height: 500, borderRadius: '50%', background: 'radial-gradient(circle, rgba(124,58,237,0.5) 0%, transparent 70%)', pointerEvents: 'none' }} />

        <div style={{ position: 'relative', zIndex: 2, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          {/* Logo réel */}
          <div style={{ filter: 'drop-shadow(0 0 40px rgba(201,169,110,0.35))', marginBottom: 8 }}>
            <img
              src="/logo-banner.jpeg"
              alt="SS Parfumerie"
              style={{
                width: 'clamp(220px, 40vw, 380px)',
                height: 'auto',
                borderRadius: '50%',
                objectFit: 'cover',
                objectPosition: 'center',
                aspectRatio: '1',
                border: `2px solid rgba(201,169,110,0.4)`,
              }}
            />
          </div>

          {/* Ligne décorative */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 14, margin: '24px 0' }}>
            <div style={{ height: 1, width: 60, background: `linear-gradient(to right, transparent, ${GOLD})` }} />
            <span style={{ color: GOLD, fontSize: 16 }}>✦</span>
            <div style={{ height: 1, width: 60, background: `linear-gradient(to left, transparent, ${GOLD})` }} />
          </div>

          <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.72)', maxWidth: 440, margin: '0 auto 40px', lineHeight: 2, fontWeight: 300 }}>
            Des fragrances authentiques soigneusement sélectionnées,<br />
            livrées directement à votre porte partout au Sénégal.
          </p>

          {/* CTAs */}
          <div className="ss-hero-btns" style={{ display: 'flex', gap: 14, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/catalogue" style={{
              background: GOLD, color: '#fff',
              padding: '15px 44px', fontSize: 11, letterSpacing: 4,
              textTransform: 'uppercase', textDecoration: 'none',
              fontFamily: sans, fontWeight: 700,
              boxShadow: '0 6px 24px rgba(201,169,110,0.45)',
              display: 'inline-block',
            }}>
              Découvrir
            </Link>
            <Link to="/suivi-commandes" style={{
              background: 'transparent', color: '#fff',
              padding: '15px 40px', fontSize: 11, letterSpacing: 4,
              textTransform: 'uppercase', textDecoration: 'none',
              fontFamily: sans, fontWeight: 500,
              border: '1px solid rgba(255,255,255,0.35)',
              display: 'inline-block',
            }}>
              Suivre ma commande
            </Link>
          </div>
        </div>

        {/* Scroll hint */}
        <div style={{ position: 'absolute', bottom: 24, left: '50%', transform: 'translateX(-50%)', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6, zIndex: 2 }}>
          <span style={{ fontSize: 9, letterSpacing: 3, color: 'rgba(255,255,255,0.3)', textTransform: 'uppercase' }}>Découvrir</span>
          <div style={{ width: 1, height: 32, background: 'linear-gradient(to bottom, rgba(201,169,110,0.5), transparent)' }} />
        </div>
      </section>

      {/* ══ STATS ══ */}
      <section style={{ background: '#1A0533' }}>
        <div className="ss-grid-4" style={{ maxWidth: 1000, margin: '0 auto' }}>
          {[
            { v: '500+',    l: 'Références' },
            { v: '10 000+', l: 'Clients satisfaits' },
            { v: '24h',     l: 'Livraison express' },
            { v: '100%',    l: 'Authenticité' },
          ].map((s, i) => (
            <div key={s.l} style={{ textAlign: 'center', padding: '2rem 1rem', borderRight: i < 3 ? '1px solid rgba(201,169,110,0.15)' : 'none' }}>
              <p style={{ fontFamily: serif, fontSize: 32, color: GOLD, fontWeight: 400, marginBottom: 6 }}>{s.v}</p>
              <p style={{ fontSize: 10, letterSpacing: 3, color: 'rgba(255,255,255,0.5)', textTransform: 'uppercase', fontFamily: sans }}>{s.l}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ══ SECTION AMBIANCE ══ */}
      <section style={{ background: '#fff', overflow: 'hidden' }}>
        <div className="ss-ambiance" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', minHeight: 560 }}>

          {/* Image */}
          <div style={{ position: 'relative', overflow: 'hidden' }}>
            <img
              src="/parfum-hero.jpeg"
              alt="Parfum de luxe"
              style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center', display: 'block', transition: 'transform .8s ease' }}
              onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.04)'}
              onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
            />
            {/* Overlay dégradé sur le bord droit */}
            <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to right, transparent 60%, #fff)', pointerEvents: 'none' }} />
          </div>

          {/* Texte */}
          <div style={{
            display: 'flex', flexDirection: 'column', justifyContent: 'center',
            padding: 'clamp(2rem, 5vw, 5rem)',
            background: '#fff',
          }}>
            <p style={{ fontSize: 10, letterSpacing: 5, color: GOLD, textTransform: 'uppercase', fontFamily: sans, fontWeight: 600, marginBottom: 20 }}>✦ Notre sélection ✦</p>
            <h2 style={{ fontFamily: serif, fontSize: 'clamp(28px, 4vw, 48px)', fontWeight: 400, color: '#1A0533', lineHeight: 1.2, marginBottom: 20 }}>
              L'Art de la<br /><em style={{ color: GOLD, fontStyle: 'italic' }}>Fragrance</em>
            </h2>
            <div style={{ width: 50, height: 1, background: GOLD, marginBottom: 24 }} />
            <p style={{ fontSize: 14, color: '#777', lineHeight: 1.9, fontWeight: 300, maxWidth: 380, marginBottom: 36 }}>
              Chaque flacon raconte une histoire unique. Nos parfums sont soigneusement sélectionnés parmi les meilleures maisons pour vous offrir une expérience olfactive inoubliable.
            </p>
            <Link to="/catalogue" style={{
              display: 'inline-flex', alignItems: 'center', gap: 10,
              background: '#1A0533', color: '#fff',
              padding: '14px 32px', fontSize: 11, letterSpacing: 3,
              textTransform: 'uppercase', textDecoration: 'none',
              fontFamily: sans, fontWeight: 600, alignSelf: 'flex-start',
              transition: 'background .3s',
            }}
              onMouseEnter={e => e.currentTarget.style.background = GOLD}
              onMouseLeave={e => e.currentTarget.style.background = '#1A0533'}>
              Voir la collection <span style={{ fontSize: 16 }}>→</span>
            </Link>
          </div>
        </div>
      </section>

      {/* ══ COLLECTIONS ══ */}
      <section style={{ padding: '6rem 2rem', background: '#FDFCFF' }}>
        <div style={{ maxWidth: 1060, margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: 48 }}>
            <p style={{ fontSize: 10, letterSpacing: 5, color: GOLD, textTransform: 'uppercase', fontFamily: sans, fontWeight: 600, marginBottom: 14 }}>✦ Explorer ✦</p>
            <h2 style={{ fontFamily: serif, fontSize: 'clamp(28px, 5vw, 52px)', fontWeight: 400, color: '#1A0533' }}>Nos Collections</h2>
            <div style={{ width: 60, height: 1, background: GOLD, margin: '18px auto 0' }} />
          </div>
          <div className="ss-grid-cats">
            {categories.map(c => (
              <Link key={c.name} to={`/catalogue?famille=${c.name}`} style={{ textDecoration: 'none' }}>
                <div style={{ background: '#fff', border: '1px solid #EDE9FE', borderRadius: 2, padding: '2rem 1rem', textAlign: 'center', transition: 'all .25s' }}
                  onMouseEnter={e => { e.currentTarget.style.borderColor = GOLD; e.currentTarget.style.background = '#FDF8F0'; e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = '0 8px 24px rgba(201,169,110,0.15)'; }}
                  onMouseLeave={e => { e.currentTarget.style.borderColor = '#EDE9FE'; e.currentTarget.style.background = '#fff'; e.currentTarget.style.transform = ''; e.currentTarget.style.boxShadow = ''; }}>
                  <div style={{ fontSize: 26, marginBottom: 10 }}>{c.icon}</div>
                  <p style={{ fontFamily: serif, fontSize: 16, color: '#1A0533', marginBottom: 5, fontWeight: 400 }}>{c.name}</p>
                  <p style={{ fontSize: 11, color: '#AAA', fontFamily: sans }}>{c.desc}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* ══ PRODUITS VEDETTES ══ */}
      {featured.length > 0 && (
        <section style={{ padding: '6rem 2rem', background: '#fff' }}>
          <div style={{ maxWidth: 1100, margin: '0 auto' }}>
            <div style={{ textAlign: 'center', marginBottom: 48 }}>
              <p style={{ fontSize: 10, letterSpacing: 5, color: GOLD, textTransform: 'uppercase', fontFamily: sans, fontWeight: 600, marginBottom: 14 }}>✦ Sélection ✦</p>
              <h2 style={{ fontFamily: serif, fontSize: 'clamp(28px, 5vw, 52px)', fontWeight: 400, color: '#1A0533' }}>Nos Meilleures Ventes</h2>
              <div style={{ width: 60, height: 1, background: GOLD, margin: '18px auto 0' }} />
            </div>
            <div className="ss-grid-prods">
              {featured.map(p => {
                const v = p.variants?.[0];
                return (
                  <div key={p._id} style={{ border: '1px solid #F0ECFF', borderRadius: 2, overflow: 'hidden', background: '#fff', transition: 'all .3s' }}
                    onMouseEnter={e => { e.currentTarget.style.boxShadow = '0 12px 40px rgba(26,5,51,0.12)'; e.currentTarget.style.borderColor = GOLD; }}
                    onMouseLeave={e => { e.currentTarget.style.boxShadow = 'none'; e.currentTarget.style.borderColor = '#F0ECFF'; }}>
                    <Link to={`/produit/${p._id}`} style={{ textDecoration: 'none', display: 'block', position: 'relative' }}>
                      <ProductImage images={p.images} name={p.name} height={200} />
                      {p.badge && (
                        <span style={{ position: 'absolute', top: 12, left: 12, fontSize: 9, background: GOLD, color: '#fff', padding: '3px 10px', letterSpacing: 2, fontFamily: sans, fontWeight: 600 }}>
                          {p.badge.toUpperCase()}
                        </span>
                      )}
                    </Link>
                    <div style={{ padding: '1.25rem' }}>
                      <p style={{ fontSize: 10, letterSpacing: 2, color: '#AAA', textTransform: 'uppercase', fontFamily: sans, marginBottom: 5 }}>{p.famille}</p>
                      <Link to={`/produit/${p._id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                        <h3 style={{ fontFamily: serif, fontSize: 18, color: '#1A0533', marginBottom: 12, lineHeight: 1.3, fontWeight: 400 }}>{p.name}</h3>
                      </Link>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>
                        <div>
                          <span style={{ fontFamily: serif, color: VD, fontSize: 22, fontWeight: 400 }}>{v?.price?.toLocaleString()}</span>
                          <span style={{ fontSize: 11, color: '#AAA', fontFamily: sans, marginLeft: 4 }}>FCFA</span>
                        </div>
                        <button onClick={() => { addItem(p, v?.size); toast.success(`${p.name} ajouté`); }}
                          style={{ background: VD, color: '#fff', border: 'none', padding: '10px 16px', fontSize: 10, letterSpacing: 2, textTransform: 'uppercase', cursor: 'pointer', fontFamily: sans, fontWeight: 600 }}
                          onMouseEnter={e => e.currentTarget.style.background = GOLD}
                          onMouseLeave={e => e.currentTarget.style.background = VD}>
                          + Panier
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
            <div style={{ textAlign: 'center', marginTop: 44 }}>
              <Link to="/catalogue" style={{ display: 'inline-block', color: VD, fontSize: 11, letterSpacing: 4, textTransform: 'uppercase', textDecoration: 'none', fontFamily: sans, fontWeight: 600, borderBottom: `2px solid ${GOLD}`, paddingBottom: 4 }}>
                Voir tout le catalogue →
              </Link>
            </div>
          </div>
        </section>
      )}

      {/* ══ ENGAGEMENTS ══ */}
      <section style={{ padding: '6rem 2rem', background: 'linear-gradient(135deg, #1A0533, #3B0764)' }}>
        <div style={{ maxWidth: 900, margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: 48 }}>
            <p style={{ fontSize: 10, letterSpacing: 5, color: GOLD, textTransform: 'uppercase', fontFamily: sans, fontWeight: 600, marginBottom: 14 }}>✦ Notre promesse ✦</p>
            <h2 style={{ fontFamily: serif, fontSize: 'clamp(26px, 4vw, 44px)', fontWeight: 400, color: '#fff' }}>Pourquoi nous choisir</h2>
          </div>
          <div className="ss-grid-3">
            {promises.map(p => (
              <div key={p.t} style={{ textAlign: 'center' }}>
                <div style={{ width: 60, height: 60, borderRadius: '50%', border: `1px solid ${GOLD}`, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 18px', color: GOLD, fontSize: 18 }}>{p.icon}</div>
                <h3 style={{ fontFamily: serif, fontSize: 20, color: '#fff', marginBottom: 10, fontWeight: 400 }}>{p.t}</h3>
                <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.6)', lineHeight: 1.8, fontWeight: 300 }}>{p.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══ COMMENT COMMANDER ══ */}
      <section style={{ padding: '6rem 2rem', background: '#FDFCFF' }}>
        <div style={{ maxWidth: 900, margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: 48 }}>
            <p style={{ fontSize: 10, letterSpacing: 5, color: GOLD, textTransform: 'uppercase', fontFamily: sans, fontWeight: 600, marginBottom: 14 }}>✦ Simple & rapide ✦</p>
            <h2 style={{ fontFamily: serif, fontSize: 'clamp(26px, 4vw, 44px)', fontWeight: 400, color: '#1A0533' }}>Comment commander</h2>
            <div style={{ width: 60, height: 1, background: GOLD, margin: '18px auto 0' }} />
          </div>
          <div className="ss-grid-3">
            {[
              { n: '01', t: 'Choisissez', d: 'Parcourez notre catalogue et sélectionnez vos fragrances préférées.' },
              { n: '02', t: 'Commandez',  d: 'Payez en toute sécurité par carte bancaire ou Orange Money.' },
              { n: '03', t: 'Recevez',    d: 'Livraison rapide à votre porte partout au Sénégal sous 24–48h.' },
            ].map(s => (
              <div key={s.n} style={{ textAlign: 'center' }}>
                <p style={{ fontFamily: serif, fontSize: 44, color: 'rgba(201,169,110,0.2)', lineHeight: 1 }}>{s.n}</p>
                <h3 style={{ fontFamily: serif, fontSize: 22, color: '#1A0533', marginBottom: 10, fontWeight: 400 }}>{s.t}</h3>
                <p style={{ fontSize: 13, color: '#888', lineHeight: 1.9, fontWeight: 300 }}>{s.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══ FOOTER ══ */}
      <footer style={{ background: '#0D0020', padding: '4rem 2rem 2rem' }}>
        <div style={{ maxWidth: 1060, margin: '0 auto' }}>
          <div className="ss-grid-footer" style={{ marginBottom: 40 }}>
            <div>
              <img src="/logo-banner.jpeg" alt="SS Parfumerie" style={{ width: 80, height: 80, borderRadius: '50%', objectFit: 'cover', objectPosition: 'center', marginBottom: 14, opacity: 0.9 }} />
              <p style={{ fontSize: 12, color: 'rgba(255,255,255,0.45)', lineHeight: 1.8, fontWeight: 300 }}>
                Fragrances authentiques livrées partout au Sénégal.
              </p>
            </div>
            <div>
              <p style={{ fontSize: 10, letterSpacing: 3, color: GOLD, textTransform: 'uppercase', marginBottom: 18, fontFamily: sans, fontWeight: 600 }}>Navigation</p>
              {[['/', 'Accueil'], ['/catalogue', 'Catalogue'], ['/suivi-commandes', 'Suivi commande'], ['/login', 'Mon compte']].map(([to, l]) => (
                <Link key={to} to={to} style={{ display: 'block', color: 'rgba(255,255,255,0.5)', textDecoration: 'none', fontSize: 13, marginBottom: 10, fontWeight: 300 }}
                  onMouseEnter={e => e.target.style.color = GOLD}
                  onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.5)'}>
                  {l}
                </Link>
              ))}
            </div>
            <div>
              <p style={{ fontSize: 10, letterSpacing: 3, color: GOLD, textTransform: 'uppercase', marginBottom: 18, fontFamily: sans, fontWeight: 600 }}>Contact</p>
              <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.5)', marginBottom: 8, fontWeight: 300 }}>📱 Orange Money</p>
              <p style={{ fontSize: 16, color: '#fff', marginBottom: 14, fontFamily: serif }}>+221 77 376 96 21</p>
              <p style={{ fontSize: 12, color: 'rgba(255,255,255,0.4)', lineHeight: 1.7, fontWeight: 300 }}>
                Livraison partout au Sénégal<br />Du lundi au samedi
              </p>
            </div>
          </div>
          <div style={{ borderTop: '1px solid rgba(201,169,110,0.15)', paddingTop: 20, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 10 }}>
            <p style={{ fontSize: 12, color: 'rgba(255,255,255,0.3)', fontFamily: sans }}>© 2025 SS Parfumerie — Tous droits réservés</p>
            <p style={{ fontSize: 11, color: 'rgba(255,255,255,0.3)', fontFamily: sans, letterSpacing: 2 }}>FAIT AVEC ✦ AU SÉNÉGAL</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
